import DomainService from "@/helpers/apiServices/superAdmin/domain.service";
import AuthService from "@/helpers/authServices/auth.service";
import MediaServices from "@/helpers/apiServices/media.service.js";
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";

const user =
  JSON.parse(sessionStorage.getItem("user")) ??
  JSON.parse(localStorage.getItem("user"));
const domain = JSON.parse(sessionStorage.getItem("domain"));
const domainList = JSON.parse(sessionStorage.getItem("domains"));
const MOHList = JSON.parse(sessionStorage.getItem("MOH"));

export const state = user
  ? {
      status: { loggedIn: true },
      user,
      domain,
      domains: domainList,
      MOH: MOHList,
      fingerPrint: null,
    }
  : {
      status: { loggedIn: false },
      user: null,
      domain: null,
      domains: null,
      MOH: null,
      fingerPrint: null,
    };

export const actions = {
  login({ commit }, user) {
    return AuthService.login(user).then(
      (user) => {
        if (user.status) {
          commit("loginSuccess", user);
          return Promise.resolve(user.user);
        } else {
          commit("loginFailure");
          return Promise.reject("Invlid Login details.");
        }
      },
      (error) => {
        commit("loginFailure");
        return Promise.reject(error);
      }
    );
  },
  accessTokenUpdate({ commit }, user) {
    return AuthService.login(user).then(
      (user) => {
        if (user.status) {
          commit("loginSuccess", user);
          return Promise.resolve(user.user);
        } else {
          commit("loginFailure");
          return Promise.reject("Invlid Login details.");
        }
      },
      (error) => {
        commit("loginFailure");
        return Promise.reject(error);
      }
    );
  },
  loginByOTP({ commit }, user) {
    return AuthService.loginWithOTP(user).then(
      (user) => {
        commit("loginSuccess", user);
        return Promise.resolve(user.user ? user.user : user);
      },
      (error) => {
        commit("loginFailure");
        return Promise.reject(error);
      }
    );
  },
  setDomain({ commit }, domain_uuid) {
    if (typeof domain_uuid !== "object") {
      return DomainService.getDomainDetails(domain_uuid).then(
        (domain) => {
          commit("setDomainSuccess", domain);
          return Promise.resolve(domain);
        },
        (error) => {
          commit("setDomainFailure");
          return Promise.reject(error);
        }
      );
    } else {
      commit("setDomainSuccess", domain_uuid.data);
      return Promise.resolve(domain_uuid.data);
    }
  },
  setDomains({ commit }, domains) {
    if (domains) {
      commit("setDomainsSuccess", domains);
      return Promise.resolve(domains);
    } else {
      return DomainService.getDomainList().then(
        (response) => {
          commit("setDomainsSuccess", response.result);
          return Promise.resolve(response);
        },
        (error) => {
          commit("setDomainsFailure");
          return Promise.reject(error);
        }
      );
    }
  },
  setMOH({ commit }, MOH) {
    if (MOH) {
      commit("setMOHSuccess", MOH);
      return Promise.resolve(MOH);
    } else {
      return MediaServices.getMohList().then(
        (response) => {
          commit("setMOHSuccess", response.result);
          return Promise.resolve(response);
        },
        (error) => {
          commit("setMOHFailure");
          return Promise.reject(error);
        }
      );
    }
  },
  setFingerPrint({ commit }) {
    getCurrentBrowserFingerPrint().then((fingerprint) => {
      commit("setFSP", {
        device_id: fingerprint,
      });
      return Promise.resolve(fingerprint);
    });
  },
  logout({ commit }) {
    AuthService.logout();
    commit("logout");
    window.location.reload();
  },
};

export const mutations = {
  loginSuccess(state, user) {
    state.status.loggedIn = true;
    state.user = user;
  },
  loginFailure(state) {
    state.status.loggedIn = false;
    state.user = null;
  },
  setDomainSuccess(state, domain) {
    state.domain = domain;
  },
  setDomainFailure(state) {
    state.domain = null;
  },
  setDomainsSuccess(state, domain) {
    state.domains = domain;
  },
  setDomainsFailure(state) {
    state.domains = null;
  },
  setMOHSuccess(state, domain) {
    state.domains = domain;
  },
  setMOHFailure(state) {
    state.domains = null;
  },
  setFSP(state, data) {
    state.fingerPrint = data;
  },
  logout(state) {
    state.status.loggedIn = false;
    state.user = null;
    state.MOH = null;
    state.domains = null;
    state.domain = null;
  },
};
